module.exports = {"330825001":"龙洲街道","330825002":"东华街道","330825101":"湖镇镇","330825102":"小南海镇","330825106":"詹家镇","330825109":"溪口镇","330825110":"横山镇","330825111":"塔石镇","330825201":"罗家乡","330825203":"庙下乡","330825207":"石佛乡","330825209":"社阳乡","330825211":"大街乡","330825212":"沐尘畲族乡","330825213":"模环乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330825.json
// module id = 931
// module chunks = 0